/**
 * 携带query跳转到指定页面
 * @param {string} path
 * @param {object} query
 */
export function goToWithQuery(path, query) {
  var openNewWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (process.env.NODE_ENV === 'development' || openNewWindow) {
    this.$router.push({
      path: path,
      query: query
    });
  } else {
    window.open(this.$router.resolve({
      path: path,
      query: query
    }).href, '_blank');
  }
}
/**
 * 后退n步路由记录，n默认为-1
 * @param {number} n
 */
export function goBack() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
  this.$router.go(n);
}